import { serviceMaker, methods, api } from "./index.js";

export const signin = (payload) =>
  serviceMaker(`authentication`, methods.POST, api.NGB, payload, {
  });
export const getUserDetails = () =>
  serviceMaker(`/userdetails`, methods.GET, api.NGB);
export const changePassword = (data, userId) =>
  serviceMaker(`/users/${userId}`, methods.PUT, api.NGB, data);

export const refreshToken = (payload) =>
  serviceMaker(`/authentication/refresh`, methods.POST, api.NGB, payload, {
  });
